import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { IconFunctionalHouse16 } from '@cian/ui-kit-design-tokens/icons';
import clsx from 'clsx';
import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import * as styles from '../styles.css';

interface IGetIcon {
  isActive?: boolean;
  isViewed?: boolean;
}

export const getBuildingIcon = ({ isActive, isViewed }: IGetIcon) => {
  let color: TColors = isViewed ? 'icon-inverted-disabled' : 'icon-inverted-default';
  if (isActive) {
    color = 'icon-positive-default';
  }

  return renderToStaticMarkup(
    <div
      className={clsx(
        styles['building-icon'],
        isActive && styles['building-icon--active'],
        isViewed && styles['building-icon--viewed'],
      )}
    >
      {createElement(IconFunctionalHouse16, { color })}
    </div>,
  );
};
